const mutations = {
  'SET_WITHDRAWALS' (state, value) {
    state.withdrawals = value
  },
  'SET_WITHDRAWAL_VOUCHER' (state, data) {
    state.withdrawal.voucher = data
  }
}
export default mutations
